import * as React from 'react';
import { connect } from 'react-redux';

import Select from 'react-select';

import { ApplicationState } from '../../store';

import * as Stores from '../../store/config/EmployeeMaster';
import * as Models from '../../models/config/Employee';

import Pagination from '@material-ui/lab/Pagination';
import { Table, ButtonGroup, Button as RBButton } from 'react-bootstrap';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Row, Col, Form, FormGroup } from 'reactstrap';
import Swal from 'sweetalert2';
import { Spinner } from 'reactstrap';
import { FaPlusCircle, FaTimesCircle, FaCheckCircle } from 'react-icons/fa';
import './../lis.css';

import EmployeeMasterSearchComponent from '../Employee/EmployeeMasterSearchComponent'

type Store = Models.EmployeeState & typeof Stores.actionCreators;

type RoleOption = { value: string, label: string };
type CompanyOption = { value: string, label: string };

class EmployeeMasterComponent extends React.PureComponent<any, { roleAccess: string, userName: string, valueSelectSearch: string, page: number, pageSize: number, pageBtn: any, valueRole: RoleOption | null, valueSelectRole: RoleOption[], valueSelectCompany: CompanyOption | null, companyOptions: CompanyOption[], version: number, modelEmployee: any, listModelEmployee: any, isOpenModal: boolean, manageMode: string }, Store> {

    constructor(props: any) {
        super(props);

        this.state = {
            version: 0,
            modelEmployee: [],
            listModelEmployee: [],
            isOpenModal: false,
            manageMode: "Select",
            valueSelectRole: [
                { value: 'user', label: 'user' },
                { value: 'admin', label: 'admin' },
                { value: 'super_admin', label: 'super_admin' }
            ],
            valueRole: null,
            valueSelectCompany: null,
            companyOptions: [],
            pageBtn: [],
            pageSize: 100,
            page: 1,
            valueSelectSearch: "",
            userName: "",
            roleAccess: "",
        }

    }

    public componentDidMount() {
        this.ensureDataFetched();
        this.fetchCompanyOptions();
    }

    private ensureDataFetched() {
        this.setState({ manageMode: "Select" })
        this.props.requestFunction(this.state.version, "GET", this.state.modelEmployee, false, null, "", "", "", 1, 100);
    }

    // Populates the company picker in the Add/Edit modal. The backend already scopes this to
    // whichever companies the logged-in caller is allowed to manage (unrestricted "*" accounts
    // get every company) - the frontend just renders whatever it gets back.
    //
    // The UAT company_master data has some noise where company_code doesn't actually correspond
    // to the company_name shown (mismatched test records) - only keep entries where the code
    // genuinely appears in the name, so the picker doesn't show nonsense combinations.
    private fetchCompanyOptions() {
        fetch(`/v1/company_master?sid=&status=active`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION')
            }
        })
            .then(response => response.json())
            .then(data => {
                const options: CompanyOption[] = (data?.result_list ?? [])
                    .filter((c: any) => typeof c.company_name === 'string' && c.company_name.includes(c.company_code))
                    .map((c: any) => ({
                        value: c.company_code,
                        label: `${c.company_code} : ${c.company_name}`,
                    }))
                // If the caller only has exactly one company available, there's nothing to pick -
                // lock the Add form to it automatically (see setBodyModal/openModalAdd).
                this.setState({
                    companyOptions: options,
                    valueSelectCompany: options.length === 1 ? options[0] : this.state.valueSelectCompany,
                })
            })
            .catch(() => {
                this.setState({ companyOptions: [] })
            })
    }

    handleChangeCompany = (newValue: CompanyOption | null) => {
        this.setState({ valueSelectCompany: newValue })
    };

    toggleModal = () => {
        this.setState({ isOpenModal: !this.state.isOpenModal })
    }

    addClickAndEdit = () => {
        const { valueRole } = this.state
        const { valueSelectSearch, userName, roleAccess } = this.state

        const userId = document.getElementById("userId") as HTMLInputElement;

        if (!userId || userId.value == "") {
            Swal.fire({
                title: 'ไม่สำเร็จ',
                text: 'กรุณากรองข้อมูลในช่อง User ID',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ใช่',
            })
            return
        }

        if (!valueRole || !valueRole.value) {
            Swal.fire({
                title: 'ไม่สำเร็จ',
                text: 'กรุณาเลือก Role Access',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ใช่',
            })
            return
        }

        // The backend validates that the caller is actually authorized for whichever company_code
        // is submitted here (against the caller's own account, not this input) before accepting it.
        const companyCode = this.state.valueSelectCompany?.value

        if (!companyCode) {
            Swal.fire({
                title: 'ไม่สำเร็จ',
                text: 'กรุณากรองข้อมูลในช่อง Company Code',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ใช่',
            })
            return
        }

        var data = [{
            id: userId.value,
            list_company: [{
                sid: "555",
                role_access: valueRole.value,
                company_code: companyCode
            }]
        }]

        this.setState({
            page: 1
        })

        this.props.requestFunction(this.state.version, "POST", data, false, null, valueSelectSearch, userName, roleAccess, 1, this.state.pageSize);
    }

    openModalAdd = () => {
        const { companyOptions } = this.state
        this.setState({
            manageMode: "Add",
            // New employees are always added as admin - locked, not user-selectable.
            valueRole: { value: 'admin', label: 'admin' },
            // If there's only one company available, lock the picker to it (see setBodyModal).
            valueSelectCompany: companyOptions.length === 1 ? companyOptions[0] : null,
            isOpenModal: true
        });
    }

    openModalDelete = (data: Models.EmployeeMain) => {
        const { valueSelectSearch, userName, roleAccess } = this.state

        Swal.fire({
            title: 'ลบข้อมูล ' + data.id + ' ?',
            text: 'คุณต้องการลบหรือไม่ ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: '✔ ใช่',
            cancelButtonText: '✖ ไม่',
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                this.setState({
                    page: 1
                })
                this.props.requestFunction(this.state.version, "DELETE", data, false, null, valueSelectSearch, userName, roleAccess, 1, this.state.pageSize);
            }
        })
    }

    handleChangeRole = (newValue: RoleOption | null) => {
        this.setState({ valueRole: newValue })
    };

    // isMutation is true after Add/Delete (or the still-backend-supported Edit). Those endpoints'
    // own response bodies aren't guaranteed to respect the current search filter (or, for Add,
    // even the company-access scoping GetEmployee applies) - so instead of trusting that response
    // as the new list, re-run the same filtered GET the Search button uses.
    afterCallApiSuccess = (isMutation: boolean) => {
        if (this.props.responseEmployee != null && this.props.statusEmployee == 200) {
            this.setState({ isOpenModal: false })

            if (isMutation) {
                const { valueSelectSearch, userName, roleAccess } = this.state
                // Must use props.versionEmployee (the version this very mutation just landed at),
                // not state.version - render() is about to sync state.version up to
                // props.versionEmployee right after this call returns, and the GET dispatched here
                // resolves asynchronously later. If it were based on the (about to be stale)
                // state.version, the resulting version tag could end up behind the already-synced
                // state.version by the time the response arrives, and render()'s
                // `versionEmployee > state.version` guard would silently swallow the refresh -
                // which is exactly why the newly added user wasn't showing up without a manual Search.
                this.props.requestFunction(this.props.versionEmployee, "GET", this.state.modelEmployee, false, null, valueSelectSearch, userName, roleAccess, this.state.page, this.state.pageSize);
                return
            }

            var countingPage: any = 0
            var dataArr: any = []
            countingPage = Math.ceil(this.props.responseEmployee['total_count'] / this.state.pageSize)

            for (let i = 0; i < countingPage; i++) {
                var data: any = {}
                data['page'] = i + 1
                dataArr.push(data)
            }

            this.setState({
                pageBtn: dataArr
            })

            this.setState({
                listModelEmployee: this.props.responseEmployee.result_list != null ? (this.props.responseEmployee.result_list as Array<Models.EmployeeMain>).slice().sort((a, b) => {
                    const idCompare = a.id.localeCompare(b.id);
                    if (idCompare !== 0) return idCompare;
                    const aCode = (a.list_company[0]?.company_code ?? "");
                    const bCode = (b.list_company[0]?.company_code ?? "");
                    return aCode.localeCompare(bCode);
                }) : [],
            });
        }
        else {
            this.setState({
                isOpenModal: false
            });

            if (this.state.manageMode != "Select") {
                this.props.requestFunction(this.state.version, "GET", this.state.modelEmployee, false, null);
            }
        }
    }

    componentDidUpdate() {
        const { statusEmployee, isLoadingEmployee } = this.props
        const { valueSelectSearch, userName, roleAccess } = this.state

        if (!isLoadingEmployee && statusEmployee == 204) {
            this.setState({
                isOpenModal: false
            });
            Swal.fire({
                title: 'ไม่สำเร็จ',
                text: "Username ซ้ำกับข้อมูลที่มีอยู่",
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ใช่',
                allowOutsideClick: false
            }).then((result) => {
                if (result.value) {
                    this.props.requestFunction(this.state.version, "GET", "", false, null, valueSelectSearch, userName, roleAccess, 1, this.state.pageSize);
                }
            })
        }
    }

    haddleChangePage = (pageNo: any, pagesize: any) => {
        const { valueSelectSearch, userName, roleAccess } = this.state

        var pagesizeUse: any
        if (pagesize != "") {
            pagesizeUse = pagesize
        } else {
            pagesizeUse = this.state.pageSize
        }

        this.setState({
            page: pageNo
        })

        this.props.requestFunction(this.state.version, "GET", "", false, null, valueSelectSearch, userName, roleAccess, pageNo, pagesizeUse);
    }

    BeforehandleChangePage = (event, value) => {
        this.haddleChangePage(value, '')
    }

    handlePageSize = (e) => {
        this.setState({ pageSize: e.target.value })
        this.haddleChangePage(this.state.page, e.target.value)
    }

    handleSearchValue = (userName, roleAccess) => {
        var valueSelectSearch = this.state.valueSelectSearch

        this.setState({
            userName: userName,
            roleAccess: roleAccess
        })

        this.props.requestFunction(this.state.version, "GET", this.state.modelEmployee, false, null, valueSelectSearch, userName, roleAccess, 1, this.state.pageSize);
    }

    setBodyModal = () => {
        const { manageMode, valueSelectCompany, companyOptions } = this.state;

        const selectStyles = {
            menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
        };

        if (manageMode == "Add") {
            return <div>
                <Row>
                    <Col xs="4"><span style={{ fontSize: 16, fontWeight: "bold" }}>User</span></Col>
                    <Col xs="8"><span style={{ fontSize: 16, fontWeight: "bold" }}>บริษัท</span></Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col xs="4">
                        <Form>
                            <Input bsSize="sm" type="text" id="userId" />
                        </Form>
                    </Col>
                    <Col xs="8">
                        {companyOptions.length === 1 ? (
                            <Form>
                                <Input bsSize="sm" type="text" value={companyOptions[0].label} disabled />
                            </Form>
                        ) : (
                            <Select
                                menuPortalTarget={document.body}
                                styles={selectStyles}
                                placeholder="เลือก บริษัท"
                                value={valueSelectCompany}
                                onChange={(value) => this.handleChangeCompany(value as CompanyOption | null)}
                                options={companyOptions}
                                isClearable
                            />
                        )}
                    </Col>
                </Row>
            </div>;
        }
    }

    setButtonModal = () => {
        if (this.state.manageMode == "Add") {
            return <RBButton variant="primary" onClick={this.addClickAndEdit}><FaCheckCircle /> Save</RBButton>;
        }
    }

    render() {
        const { listModelEmployee, valueSelectRole } = this.state
        if (this.props.versionEmployee > this.state.version) {
            if (this.props.versionEmployee - this.state.version == 2) {//get
                this.afterCallApiSuccess(false);

            } else if (this.props.versionEmployee - this.state.version == 3) {//post
                this.afterCallApiSuccess(true);

            } else if (this.props.versionEmployee - this.state.version == 5) {//put
                this.afterCallApiSuccess(true);

            } else if (this.props.versionEmployee - this.state.version == 6) {//delete
                this.afterCallApiSuccess(true);

            }

            this.setState({ version: this.props.versionEmployee });
        }

        return (
            <div>
                <div>
                    <div className='trapezoid' style={{ width: 'auto', display: 'inline-block' }}>
                        <span className="employee-font">
                            Employee Master
                        </span>
                    </div>
                    <div style={{ display: 'inline', float: 'right' }}>
                        <RBButton variant="info" size="sm" style={{ float: 'right', marginLeft: '5px' }} onClick={this.openModalAdd}><FaPlusCircle style={{ marginBottom: '4px' }} /> Add</RBButton>
                    </div>
                </div>
                <div className="mat-box shadow p-3 mb-5 bg-white rounded">
                    <EmployeeMasterSearchComponent valueSelectRole={this.state.valueSelectRole} handleSearchValue={this.handleSearchValue.bind(this)} />
                    <Row>
                        <Col xs={6}>
                            <div className='d-flex justify-content-start my-2 my-lg-0'>
                                <Form inline>
                                    <Label style={{ fontSize: '14px' }}>
                                        Show&nbsp;&nbsp;
                                    </Label>
                                    <Input
                                        type="select"
                                        name="select"
                                        bsSize="sm"
                                        value={this.state.pageSize}
                                        onChange={this.handlePageSize}
                                    >
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </Input >
                                    <Label style={{ fontSize: '14px' }}>
                                        &nbsp;&nbsp;entries
                                    </Label>
                                </Form>
                            </div>
                        </Col>
                        <Col xs={6}>
                            <div className='d-flex justify-content-end my-2 my-lg-0'>
                                <Pagination count={this.state.pageBtn.length != 0 && this.state.pageBtn.length} shape="rounded" defaultPage={1} showFirstButton showLastButton onChange={this.BeforehandleChangePage} page={this.state.page} />
                            </div>
                        </Col>
                    </Row>
                    <div className="mt-3">
                        <Table className="table-bordered table-hover custom-table-list table-responsive-lg" size="sm">
                            <thead >
                                <tr style={{ width: '100%' }} className="text-center table-active thead-light require-field">
                                    <th className="td-menu" style={{ width: '10%', top: -1, position: 'sticky', zIndex: 1 }} ></th>
                                    <th style={{ width: '40%', position: 'sticky', top: -1, zIndex: 1 }} className="td-id" >Username</th>
                                    <th style={{ width: '25%', position: 'sticky', top: -1, zIndex: 1 }} className="td-id" >Company Code</th>
                                    <th className="td-role-access" style={{ width: '25%', top: -1, position: 'sticky', zIndex: 1 }} >Role Access</th>
                                </tr>
                            </thead>
                            {!this.props.isLoadingEmployee ? <tr><td colSpan={4} style={{ background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" }}><Spinner size="sm" color="dark" />{' '}Loading...</td></tr> : <tr></tr>}
                            {this.props.isLoadingEmployee && this.props.statusEmployee != 200 ? <tr><td colSpan={4} style={{ background: "#b7b7a4", color: "black", fontSize: '10pt', textAlign: "center" }}>No Data.</td></tr> : <tr></tr>}
                            {this.props.isLoadingEmployee && this.props.statusEmployee == 200 &&
                                <tbody>
                                    {listModelEmployee.map((item: Models.EmployeeMain, id) => {
                                        const company = item.list_company && item.list_company[0]

                                        return (
                                            <tr key={item.id}>
                                                <td className="td-menu text-center">
                                                    <ButtonGroup>
                                                        <RBButton variant="danger" size="sm" onClick={() => this.openModalDelete(item)}><FaTimesCircle /></RBButton>
                                                    </ButtonGroup>
                                                </td>
                                                <td className="td-id">{item.id}</td>
                                                <td className="td-id">{company ? company.company_code : ''}</td>
                                                <td className="td-role-access">{company ? company.role_access : ''}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            }
                        </Table>
                    </div>
                </div>
                <Modal isOpen={this.state.isOpenModal} className="modal-upload-file" style={{ minWidth: "1100px" }}>
                    <ModalHeader className="employee-font" toggle={this.toggleModal}>{this.state.manageMode + ' Employee'}</ModalHeader>
                    <ModalBody>

                        {this.setBodyModal()}

                    </ModalBody>
                    <ModalFooter>
                        {this.setButtonModal()}
                        <RBButton variant="danger" onClick={this.toggleModal}><FaTimesCircle /> Close</RBButton>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.employee }),
    ({ ...Stores.actionCreators })
)(EmployeeMasterComponent);
